module.exports = __webpack_public_path__ + "img/303-d24041.png";